/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { LoggerStore } from "../../logger/logger-store"
import type { Result } from "../../network/http-client"
import { makeGetRequest } from "../../network/http-client"

import type { ApplicationTypeStore } from "./application-type-store"
import type { ThreatOverview } from "./application-type-types"

enum Endpoint {
    stats = "/stats/api/private/application-type"
}

export class ApplicationTypeStatsService {
    constructor(
        private readonly applicationStore: ApplicationTypeStore,
        private readonly logger: LoggerStore
    ) {}

    async getThreatsOverview(appTypeIds: number[]): Promise<void> {
        await Promise.all(appTypeIds.map((appTypeId) => this.getThreatOverview(appTypeId)))
    }

    private async getThreatOverview(appTypeId: number): Promise<Result<ThreatOverview>> {
        const stats = await makeGetRequest<ThreatOverview>(`${Endpoint.stats}/${appTypeId}/threat-overview`, {})

        if (stats.success && stats.data) {
            this.applicationStore.setThreats(appTypeId, stats.data)
        }
        if (!stats.success) {
            this.logger.logApiError("Get threat overview failed.", stats.apiError, stats.error)
        }
        return stats
    }
}
